$('.lk-7days__form_select').selectric();
